import useSWR from "swr";
import { ConfigurationPackage, Plan } from "@/api/products";
import api from "@/api";

export const ProductFetch = (id: number) => {
  const { data, mutate, isLoading } = useSWR<Plan>(
    id ? `product_${id}` : null,
    async (): Promise<Plan> => {
      const { data: product } = await api.get<Plan>(`/core/planos/${id}`);

      const configurationPackage = (
        pacote_configuracoes: ConfigurationPackage
      ): ConfigurationPackage | undefined => {
        return pacote_configuracoes;
      };

      const config = configurationPackage(product.pacote_configuracoes);
      const packageFoundFlashSale = product.pacote_configuracoes?.flash_sale;
      const packageFoundPortability = product.pacote_configuracoes?.portability;
      const packageFoundDedicated = product.pacote_configuracoes?.dedicated;

      const shouldShowPortabilityBonus = config
        ? config.mostrar_bonus_portabilidade
        : true;
      const shouldShowDedicatedBonus = config
        ? config.mostrar_bonus_dedicado
        : true;

      const bonusPortabilidade = packageFoundPortability
        ? packageFoundPortability.gb
        : 0;

      let bonusDedicated = packageFoundDedicated ? packageFoundDedicated.gb : 0;
      bonusDedicated = shouldShowDedicatedBonus ? bonusDedicated : 0;

      let total =
        product.gb +
        (packageFoundFlashSale ? packageFoundFlashSale?.gb : 0);
      total += shouldShowPortabilityBonus ? bonusPortabilidade : 0;
      total += shouldShowDedicatedBonus ? bonusDedicated : 0;

      return {
        ...product,
        gb: total,
        gbPadrao: product.gb,
        gbBonusPortabilidade: bonusPortabilidade,
        gbBonusDedicated: bonusDedicated,
        bonusPortabilidade,
        gbPromocional: packageFoundFlashSale ? packageFoundFlashSale?.gb : 0,
        description: `${
          product.gb
        }GB
        ${
          packageFoundFlashSale
            ? `+ ${packageFoundFlashSale.gb}GB promocionais`
            : ""
        }`,
        mostrarPortabilidade: shouldShowPortabilityBonus,
        mostrarDedicado: shouldShowDedicatedBonus,
      };
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  return { data, mutate, isLoading };
};
